import { render } from "./App.vue?vue&type=template&id=037d07b4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=037d07b4&lang=css"

import exportComponent from "/home/runner/work/joshpotterton.com/joshpotterton.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__